<template>
  <b-modal :id="id" title="Thêm công thức mới" ok-title="Xác nhận" cancel-title="Đóng" size="md">
    <template #modal-header>
      <h4>Công thức mới</h4>
    </template>
    <template #default>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <b-form>
              <b-form-group label="Chọn công ty">
                <v-select plain v-model="network" :reduce="opt => opt.id" :options="networkOptions" @input="networkChange($event)" placeholder="Chọn"/>
              </b-form-group>
              <b-form-group label="Kiểu công thức">
                <v-select plain v-model="fomular_type" :options="programmed_formularTypeOptions" @input="formularTypeChange($event)" placeholder="Chọn" :disabled="onloadNetworkDisable"/>
              </b-form-group>
              <b-form-group label="Loại tiền">
                <v-select plain v-model="currency_type" :reduce="opt => opt.serverId" :options="moneyTypeOptions" placeholder="Chọn"/>
              </b-form-group>
              <b-form-group label="Hệ số">
                <b-form-input v-model="ratio"/>
              </b-form-group>
              <b-form-group label="Giá thầu">
                <b-form-input v-model="price"/>
              </b-form-group>
              <p>
                <b>Kết quả = </b> {{formular_type_description}}
              </p>
              <trasnfer-receive v-model="type_money"/>
              <span class="text-danger">{{serverError}}</span>
            </b-form>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="primary" @click="confirm" :disabled="serverRequest">Xác nhận</b-button>
      <b-button variant="default" @click="$bvModal.hide(id)">Đóng</b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import TrasnferReceive from '../misc/TrasnferReceive'
import _ from 'lodash'
import api from '../../../store/api'

export default {
  name: 'formularCreateModal',
  components: { TrasnferReceive },
  data () {
    return {
      network: null,
      fomular_type: null,
      formular_type_description: '',
      currency_type: null,
      ratio: 0,
      price: 0,
      type_money: false,
      programmed_formularTypeOptions: [],
      onloadNetworkDisable: false
    }
  },
  mounted () {
    this.programmed_formularTypeOptions = this.formularTypeOptions

    if (this.networkId) {
      this.network = this.networkId
      this.networkChange(this.networkId)
    }
  },
  watch: {
    networkId: function (newVal, oldVal) {
      if (this.networkId) {
        this.network = newVal
        this.networkChange(newVal)
      }
    }
  },
  props: {
    id: {
      type: String,
      default: 'modal-formular-1'
    },
    inputStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          display: 'block'
        }
      }
    },
    networkId: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      'networkOptions': 'Network/listOptionsState',
      'formularTypeOptions': 'Formular/listTypeOptionsState',
      'formularTypes': 'Formular/listTypeState',
      'moneyTypeOptions': 'Setting/moneyTypeState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequest': 'Setting/serverRequestingState'
    })
  },
  methods: {
    ...mapActions({
      'loadFormularByNetwork': 'Formular/loadListByNetwork',
      'loadFormularList': 'Formular/loadList'
    }),
    async confirm () {
      let requestParams = {
        'network_id': this.network,
        'type_id': this.fomular_type.id, // formula type
        'currency_id': this.currency_type,
        'ratio': this.ratio, // hệ số
        'price': this.price, // giá thầu
        'type_money': this.type_money // giao = 0 , nhận = 1
      }

      api.formular.create(requestParams).then(async (res) => {
        this.$swal({
          icon: 'success',
          title: 'Thêm thành công'
        })

        // reload
        await this.loadFormularList()
        await this.loadFormularByNetwork({
          'network_id': this.network
        })

        this.$bvModal.hide(this.id)

        this.$emit('successCreated', res.data)
      })
        .catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Lỗi...',
            text: this.serverError
          })
        })
    },
    formularTypeChange (selectedObject) {
      let formularTypeId = selectedObject.value

      let choiceFormularType = _.first(_.filter(this.formularTypes, (e) => {
        return e.id === formularTypeId
      }))

      if (choiceFormularType) {
        this.formular_type_description = choiceFormularType.description
      }
    },
    async networkChange (selectedObject) {
      this.onloadNetworkDisable = true
      this.formular_type_description = ''

      if (selectedObject == null) {
        this.programmed_formularTypeOptions = this.formularTypeOptions

        // select first
        this.fomular_type = this.programmed_formularTypeOptions[0]
      } else {
        await api.formular.listType({
          network_id: selectedObject
        }).then((res) => {
          this.programmed_formularTypeOptions = _.map(res, function (e) {
            return { id: e.id, value: e.id, text: e.name, label: e.name }
          })

          // select first
          this.fomular_type = this.programmed_formularTypeOptions[0]
        }).catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Lỗi...',
            text: this.serverError
          })
        })
      }

      this.onloadNetworkDisable = false
    }
  }
}
</script>
